
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.439 2.426L6.895 5.087a2.027 2.027 0 01-1.348.152 6.32 6.32 0 00-.578-.116C3.448 4.949 2.5 6.153 2.5 7.537v.76c0 1.383.948 2.587 2.469 2.413.122-.014.274-.048.578-.116.465-.104.92-.053 1.348.152l5.544 2.662c1.272.61 1.909.916 2.618.678.71-.238.953-.75 1.44-1.771a10.146 10.146 0 000-8.797c-.487-1.021-.73-1.532-1.44-1.77-.71-.239-1.346.067-2.618.678z","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.548 17.31l-1.242 1.023c-2.802-2.221-2.46-3.28-2.46-7.5h.945c.384 2.384 1.288 3.514 2.536 4.331.769.504.928 1.563.221 2.145zM6.25 10.417v-5","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    